import Head from 'auslfe-theme/components/Head/Head';

const applyConfig = (config) => {
  config.settings.appExtras = [
    ...config.settings.appExtras,
    // {
    //   match: '',
    //   component: Head,
    // },
  ];
  return config;
};

export default applyConfig;
